import React from 'react'

const Navbar = () => {
    const navigateTologin = () => {
        window.location.href = '/login';
    }
    const navigateToHome = () => {
        window.location.href = '/';
    }
    return (
        <div className='border-b border-b-2 border-black'>
            <div className='bg-white  flex justify-center '>
                <div className='flex justify-between  items-center text-left min-h-[00px] w-full px-4 py-2 sm:px-6  lg:max-w-7xl lg:px-8'>
                    <img onClick={navigateToHome} className='h-[90px]' src='/images/uni_logo.png' />
                    <div className='flex space-x-4'>
                        <button onClick={navigateTologin} className='text-black hidden md:block text-sm font-bold'>Login</button>
                        {/* <button className='text-black  hidden md:block  text-sm font-bold'>Hell</button> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar